import { render, staticRenderFns } from "./rightMenu.vue?vue&type=template&id=d85b845c&"
import script from "./rightMenu.vue?vue&type=script&lang=js&"
export * from "./rightMenu.vue?vue&type=script&lang=js&"
import style0 from "./rightMenu.vue?vue&type=style&index=0&id=d85b845c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports